import React, { ReactNode, useContext } from "react";

import { EnvConfig, getEnvConfig } from "@/env";

interface AppContextValue {
  config: EnvConfig | null;
}

export const AppContext = React.createContext<AppContextValue>({
  config: null,
});

interface AppContextProviderProps {
  children: ReactNode;
}

export const AppContextProvider = ({ children }: AppContextProviderProps) => {
  return (
    <AppContext.Provider
      value={{
        config: getEnvConfig(),
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useApp = () => useContext(AppContext);
